import { ResponsiveOptionsManager } from "../Base/managers/ResponsiveOptionsManager.js";
function withResponsiveOptions(BaseClass) {
  class WithResponsiveOptions extends BaseClass {
    /**
     * Get managers.
     */
    get __managers() {
      return {
        ...super.__managers,
        OptionsManager: ResponsiveOptionsManager
      };
    }
  }
  return WithResponsiveOptions;
}
export {
  withResponsiveOptions
};
//# sourceMappingURL=withResponsiveOptions.js.map
